import { create } from "apisauce";


const handleSessionExpiry = () => {
  alert("Your session has expired. Please log in again.");
  localStorage.removeItem("tokenuser");
    localStorage.removeItem("admin");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("useraddress");
    localStorage.removeItem("favourite");
    window.location.reload();
    window.location.href = "/";
    window.dispatchEvent(new Event("authChange"));
};
const createBaseApi = () => {
  const BaseApi = create({
    baseURL: process.env.REACT_APP_BASE_URL,

    // timeout: 5000, // Optional timeout, set as neededee
    withCredentials: true,
  });
  BaseApi.addResponseTransform((response) => {
    if (response.status === 401) {
    
      handleSessionExpiry();
     
      // alert("Your session has expired. Please log in again.");
    
      // localStorage.removeItem("tokenuser");
      // localStorage.removeItem("loginTime");
      // window.location.reload();
      // window.location.href = "/";
    }
  });

  return BaseApi;
};

const BaseApi = createBaseApi();

export { BaseApi };
